module.exports = __webpack_public_path__ + "media/about-us.02240d60.mp4";